export default "__VITE_ASSET__DGV25Lat__"